import { BadgeVariants } from '@/components/layout/Badge';

export const STATUS_LABEL: Record<string, string> = {
    rascunho: 'Rascunho',
    enviado: 'Enviado',
    aceito: 'Aceito',
    recusado: 'Recusado',
    expirado: 'Expirado',
    cancelado: 'Cancelado',
};

export const STATUS_BADGE: Record<string, BadgeVariants> = {
    rascunho: 'secondary',
    enviado: 'info',
    aceito: 'success',
    recusado: 'danger',
    expirado: 'warning',
    cancelado: 'light',
};

export const ORIGEM_LABEL: Record<string, string> = {
    ia: 'Agente de IA',
    fluxo: 'Fluxo de atendimento',
    formulario: 'Formulário',
    manual: 'Manual',
};

export const CANCELAVEL = ['rascunho', 'enviado'];

export const formatarData = (valor?: string | null) =>
    valor ? new Date(valor).toLocaleString('pt-BR') : '—';
